import React, { forwardRef, useCallback, useEffect, useRef, useState } from "react"
import { useNavigate, } from "react-router-dom"
import { Spinner } from "../Loading"

import "./style.scss"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../Modal"

export const ButtonActions = ({ handleClick, id, type, children }) => {
  return (
    <div className="button-actions">
      <button
        id={id}
        onClick={handleClick}
        className={`button-actions__button button-actions__button--${type || "add"}`}>
        {children}
      </button>
    </div>
  )
}


export const Button = ({
  label,
  color,
  handleClick,
  isDisabled,
  disableKeyPress,
  hasIcon,
  hiddenText,
  type,
  flexEnd,
  className,
  classButton,
  variant,
  id,
  size,
  ...props
}) => {
  const handleKeypress = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        handleClick()
      }
    },
    [handleClick],
  )

  useEffect(() => {
    if (!disableKeyPress && type === "submit") {
      document.addEventListener("keydown", handleKeypress)
      return () => document.removeEventListener("keydown", handleKeypress)
    }
  }, [handleKeypress])

  const hasVariant = !variant ? `button-content--${color || "primary"}` : ""
  const hasOutline = variant == "outline" ? `button-content-outline--${color || "primary"}` : ""
  const hasGhost = variant == "ghost" ? `button-content-ghost--${color || "primary"}` : ""

  const buttonSize = size ? `btn btn-${size}` : "button-content" 

  return (
    <div className={`button-container${className ? " " + className : ""}`} {...props}>
      <button
        type={type}
        id={id}
        onClick={handleClick}
        disabled={isDisabled}
        className={`${buttonSize} ${hasVariant} ${hasGhost} ${hasOutline}${
          hiddenText ? " hidden-button-text " : ""
        } ${classButton ? classButton : ""}`}
        style={
          (hasIcon && { justifyContent: "space-evenly" }) ||
          (flexEnd && { justifyContent: "flex-end" })
        }>
        {hasIcon && hasIcon}
        <span className="button-content__label">{label}</span>
        {props?.count && <span className="button-content__label--count">{props?.count}</span>}
      </button>
    </div>
  )
}

export const ButtonIcons = ({
  label,
  color,
  handleClick,
  isDisabled,
  type,
  iconLeft,
  iconRight,
  styles,
}) => {
  return (
    <button
      type={type}
      onClick={handleClick}
      disabled={isDisabled}
      title={label}
      className={`button-icons button-icons--${color || "primary"}`}
      style={styles && { styles }}>
      {iconLeft && <div className="icon-button--left">{iconLeft}</div>}
      <span className="button-icons__label">{label}</span>
      {iconRight && <div className="icon-button--right">{iconRight}</div>}
    </button>
  )
}

export const FormButtonArea = ({ children }) => {
  return <div className="form-button-area">{children}</div>
}

export const UploadButton = ({
  label,
  color,
  onFileChange,
  uploaded,
  isDisabled = false,
  name,
  accept,
  variant,
  loadingProcessImage,
  id = "input-file",
  isMultiple = false
}) => {
  const inputRef = useRef(null)

  const handleUpload = () => {
    inputRef.current?.click()
  }

  return (
    <div style={{ display: "flex" }}>
      <>
          <input
            id={id}
            name={name}
            ref={inputRef}
            onChange={onFileChange}
            style={{ display: "none" }}
            type="file"
            accept={accept}
            multiple={isMultiple}
          />
          <ButtonLoader
            type={"button"}
            color={color ? color : uploaded ? "primary" : "secondary"}
            label={label}
            variant={variant}
            handleClick={handleUpload}
            isDisabled={isDisabled}
            loading={loadingProcessImage}
          />
        </>
    </div>
  )
}

export const ModalPreviewFile = ({ file, typeFile, handleRemoveFile }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false)

  const handleDeleteFile = () => {
    handleRemoveFile()
    setModalIsOpen(false)
  }

  return (
    <div style={{ display: "flex" }}>
      <Button onClick={() => setModalIsOpen(true)} label="Ver Evidência" variant="ghost" />
      <ModalPanel modalIsOpen={modalIsOpen}>
      <ModalHeader closeModal={() => setModalIsOpen(!modalIsOpen)} title="Preview" />
      <ModalBody>
        <div className="content-preview">
          {typeFile === "png" || typeFile === "jpg" || typeFile === "jpeg" ? (
            <img src={file} width="100%" height="100%" />
          ) : (
            typeFile === "mp4" && <video src={file} width="100%" height="100%" controls />
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button label="Cancelar" onClick={() => setModalIsOpen(false)} color="danger" />
        <Button label="Remover" onClick={handleDeleteFile} color="orange" />
      </ModalFooter>
    </ModalPanel>
    </div>
  )
}

export const ModalConfirmButton = ({
  label,
  color,
  handleClick,
  isDisabled = false,
  hasIcon,
  type,
  flexEnd,
}) => {
  return (
    <div className="button-content">
      <button
        type={type}
        onClick={handleClick}
        disabled={isDisabled}
        className={`button__default button__default--${color || "primary"}`}
        style={
          (hasIcon && { justifyContent: "space-evenly", fontSize: "16px" }) ||
          (flexEnd && { justifyContent: "flex-end" })
        }>
        {hasIcon && hasIcon}
        {label}
      </button>
    </div>
  )
}

export const IconButtonFold = ({ collapseAction, icon }) => {
  return (
    <button id="menu" className="" onClick={() => collapseAction((collapsed) => !collapsed)}>
      {icon}
    </button>
  )
}

export const ButtonLoader = ({
  loading,
  handleClick,
  color,
  className,
  label,
  messageProcess,
  isDisabled = false,
  variant
}) => {

  const hasVariant = !variant ? `button-content--${color || "primary"}` : ""
  const hasOutline = variant == "outline" ? `button-content-outline--${color || "primary"}` : ""
  const hasGhost = variant == "ghost" ? `button-content-ghost--${color || "primary"}` : ""

  return (
    <div className={`button-container${className ? " " + className : ""}`}>
      <button
        className={`button-content ${hasVariant} ${hasGhost} ${hasOutline}`}
        onClick={handleClick}
        disabled={isDisabled || loading}>
        {loading && <Spinner size="small" color="white" />}
        <div className="button-loader-message">
          {loading && (
            <span className="button-content__label">
              {messageProcess ? messageProcess : "Processando..."}
            </span>
          )}
          {!loading && <span className="button-content__label">{label ? label : "Buscar"}</span>}
        </div>
      </button>
    </div>
  )
}

export const ToggleButton = ({
  labelEnabled,
  labelDisabled,
  hiddenLabel,
  handleSelected,
  selected,
}) => {
  return (
    <div className="toggle-container">
      <div className="toggle-content" onClick={handleSelected}>
        <div className={`toggle-button ${selected ? "" : "disabled"}`}></div>
      </div>
      {!hiddenLabel && (
        <span className="toggle-label">
          {selected ? labelEnabled || "Sim" : labelDisabled || "Não"}
        </span>
      )}
    </div>
  )
}

export const ButtonRouter = ({ to, state, ...props }) => {
  const navigate = useNavigate()

  const goTo = () => {
    navigate(to, { state })
  }

  return <Button {...props} handleClick={goTo} />
}

export const ButtonReloadPage = ({ isFetching, isLoading, lastUpdated, reload, usersScreen }) => {
  return (
    <div className="reload-button-date">
      <span className={usersScreen ? "user-reload" : ""}>
        {isFetching
          ? "Atualizando..."
          : lastUpdated
          ? `Última atualização: ${lastUpdated}`
          : isLoading
          ? "Buscando..."
          : "Atualizar"}
      </span>
      <button onClick={reload} title="Atualizar/Buscar">
        {isFetching || isLoading ? (
          <Spinner size="xsmall" color="primary" />
        ) : (
          <i className="fi fi-bs-rotate-right"></i>
        )}
      </button>
    </div>
  )
}
